import { getPageNumbers } from "./jobConstants";

const PageBtn = ({ children, onClick, disabled, active }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="min-w-[34px] h-[34px] rounded-[9px] text-[12.5px] font-semibold disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
    style={
      active
        ? { background: "#0C1120", color: "#fff", border: "1px solid #0C1120", fontFamily: "Poppins" }
        : { background: "#fff", color: "#2B3142", border: "1px solid #E0E3EB", fontFamily: "Poppins" }
    }
  >
    {children}
  </button>
);

const JobsPagination = ({ currentPage, totalPages, totalJobs, jobsPerPage, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = getPageNumbers(currentPage, totalPages);
  const startItem = (currentPage - 1) * jobsPerPage + 1;
  const endItem = Math.min(currentPage * jobsPerPage, totalJobs);

  return (
    <div className="flex items-center justify-between gap-3 mt-[18px] flex-wrap">
      <span className="text-[12.5px] text-[#8A90A2]">
        Showing {startItem}–{endItem} of {totalJobs.toLocaleString()}
      </span>
      <div className="flex gap-[5px]">
        <PageBtn onClick={() => onPageChange(1)} disabled={currentPage <= 1}>«</PageBtn>
        <PageBtn onClick={() => onPageChange(currentPage - 1)} disabled={currentPage <= 1}>‹</PageBtn>
        {pages.map((p) => (
          <PageBtn key={p} onClick={() => onPageChange(p)} active={p === currentPage}>{p}</PageBtn>
        ))}
        <PageBtn onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages}>›</PageBtn>
        <PageBtn onClick={() => onPageChange(totalPages)} disabled={currentPage >= totalPages}>»</PageBtn>
      </div>
    </div>
  );
};

export default JobsPagination;
